import Cookies from 'js-cookie'
import jwtUtils from '../utils/jwtUtils'
import { API_CONFIG } from '../config/apiConfig'

const TOKEN_COOKIE_NAME = 'ogc_auth_token'
const TOKEN_EXPIRY_DAYS = 30

class AuthService {
  async saveToken(token) {
    try {
      Cookies.set(TOKEN_COOKIE_NAME, token, {
        expires: TOKEN_EXPIRY_DAYS,
        secure: process.env.REACT_APP_NODE_ENV === 'prod',
        sameSite: 'strict',
      })
      return true
    } catch (error) {
      console.error('Erreur sauvegarde token:', error)
      return false
    }
  }

  getToken() {
    return Cookies.get(TOKEN_COOKIE_NAME) || null
  }

  removeToken() {
    Cookies.remove(TOKEN_COOKIE_NAME)
  }

  isAuthenticated() {
    const token = this.getToken()
    if (!token) return false

    return !jwtUtils.isTokenExpired(token)
  }

  getShopId() {
    const token = this.getToken()
    if (!token) return null

    return jwtUtils.getShopIdFromToken(token)
  }

  getTokenInfo() {
    const token = this.getToken()
    if (!token) return null

    return jwtUtils.extractTokenInfo(token)
  }

  isPlanExpiringSoon() {
    const token = this.getToken()
    if (!token) return false

    return jwtUtils.isPlanExpiringSoon(token, API_CONFIG.PLAN_EXPIRY_WARNING)
  }

  getDaysUntilExpiry() {
    const token = this.getToken()
    if (!token) return 0

    return jwtUtils.getDaysUntilExpiry(token)
  }

  formatExpiryDate() {
    const token = this.getToken()
    if (!token) return null

    return jwtUtils.formatPlanExpiry(token)
  }

  logout() {
    this.removeToken()
  }

  getCurrentPlan() {
    const tokenInfo = this.getTokenInfo()
    if (!tokenInfo) return null

    const planConfig = Object.values(API_CONFIG.PLANS).find(
      (p) => p.id === tokenInfo.plan,
    )

    return {
      ...planConfig,
      expiry: tokenInfo.planExpiry,
      daysLeft: tokenInfo.daysUntilExpiry,
      maxSessions: tokenInfo.maxSessions,
    }
  }

  async isOnline() {
    if (!navigator.onLine) return false

    try {
      const controller = new AbortController()
      const timeout = setTimeout(() => controller.abort(), 3000)

      const response = await fetch('https://api.ipify.org?format=json', {
        method: 'GET',
        cache: 'no-store',
        signal: controller.signal,
      })

      clearTimeout(timeout)
      return response.ok
    } catch (error) {
      console.error('⚠️Connexion internet échouée :', error)
      return false
    }
  }

  async waitForOnline(timeout = 30000) {
    if (this.isOnline()) return true

    return new Promise((resolve) => {
      const timer = setTimeout(() => {
        window.removeEventListener('online', onlineHandler)
        resolve(false)
      }, timeout)

      const onlineHandler = () => {
        clearTimeout(timer)
        window.removeEventListener('online', onlineHandler)
        resolve(true)
      }

      window.addEventListener('online', onlineHandler)
    })
  }
}

export default new AuthService()
